import { LucideIcon } from 'lucide-react';
import React from 'react';

interface ContactCardProps {
  icon: LucideIcon;
  title: string;
  items: string[];
  iconColor?: 'orange' | 'green';
  linkType?: 'phone' | 'email' | 'none';
}

export default function ContactCard({ icon: Icon, title, items, iconColor = 'orange', linkType = 'none' }: ContactCardProps) {
  const getLink = (item: string, type: string) => {
    if (type === 'phone') return `tel:${item.replace(/\s/g, '')}`;
    if (type === 'email') return `mailto:${item}`;
    return '#';
  };

  const getHoverColor = () => {
    return iconColor === 'orange' ? 'hover:text-orange-600' : 'hover:text-green-600';
  };

  return (
    <div className="bg-white rounded-xl p-5 text-center hover:shadow-xl transition-shadow">
      <Icon className={`w-12 h-12 ${iconColor === 'orange' ? 'text-orange-600' : 'text-green-600'} mx-auto mb-4`} />
      <h3 className="text-xl font-bold text-gray-900 mb-2">{title}</h3>
      <div className="space-y-2">
        {items.map((item, index) => (
          linkType !== 'none' ? (
            <a
              key={index}
              href={getLink(item, linkType)}
              className={`block text-gray-600 ${getHoverColor()} transition-colors`}
            >
              {item}
            </a>
          ) : (
            <p key={index} className="text-gray-600 leading-relaxed">
              {item}
            </p>
          )
        ))}
      </div>
    </div>
  );
}

